// src/components/auth/RequireGuest.js
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function RequireGuest({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let ativo = true;

    fetch(`${API_BASE}painel-dados.php`, {
      method: "GET",
      credentials: "include", // 🔴 essencial para sessão PHP
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(async (res) => {
        try {
          return await res.json();
        } catch {
          return null;
        }
      })
      .then((data) => {
        if (!ativo) return;

        // 🔐 Se o backend disser que está autenticado
        if (data && data.status === "sucesso") {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }

        setLoading(false);
      })
      .catch(() => {
        if (!ativo) return;
        setAuthenticated(false);
        setLoading(false);
      });

    return () => {
      ativo = false;
    };
  }, []);

  // ⏳ Enquanto verifica sessão
  if (loading) {
    return null; // depois você pode colocar um loader premium aqui
  }

  // ✅ Já logado → manda pro painel
  if (authenticated) {
    return <Navigate to="/painel" replace />;
  }

  // 🚪 Visitante → libera a página
  return children;
}
